<template>
    <div>
        <!-- Mobile: overlay sidebar using offcanvas -->
        <template v-if="isMobile">
            <div class="offcanvas offcanvas-start lateral-offcanvas" tabindex="-1"
                id="offcanvasLateral" aria-labelledby="offcanvasLateralLabel">
                <div class="offcanvas-header" style="display: none;">
                    <button id="closeSideBarLateral" type="button" class="btn text-reset" data-bs-dismiss="offcanvas"
                        aria-label="Close">
                        <span style="color:white;font-size:large"><i class="fas fa-times"></i></span>
                    </button>
                </div>
                <div class="offcanvas-body p-0 lateral-sidebar-body">
                    <div class="p-3 lateral-menu-list" style="cursor:pointer;white-space: nowrap;">
                        <div v-for="item in allMenuItems" :key="item.key" class="lateral-menu-item">
                            <div class="lateral-menu-item-inner" :style="item.styles" @click="handleItemClick(item)">
                                <div class="d-flex align-items-center">
                                    <img :src="getItemIcon(item)" class="lateral-menu-icon" :alt="item.name">
                                    <span class="lateral-menu-text flex-grow-1" :style="skin.header_desktop.nav_bar_text">{{ getItemLabel(item) }}</span>
                                    <span v-if="item.amount" class="lateral-menu-amount me-2" :style="skin.header_desktop.nav_bar_text" >{{ item.amount }}</span>
                                    <i v-if="item.children" class="fas lateral-chevron" :class="expandedItems[item.key] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                </div>
                            </div>
                            <div v-if="item.children && expandedItems[item.key]" class="lateral-submenu mb-1">
                                <template v-for="(child, cIdx) in getChildren(item)">
                                    <div v-if="child.type === 'redes'" :key="'r-'+cIdx">
                                        <div v-for="(red, rKey) in skin.redes" :key="rKey">
                                            <div v-if="red.enabled" class="lateral-menu-item">
                                                <div class="lateral-menu-item-inner lateral-subitem" @click.stop="openSocial(red.url)">
                                                    <div class="d-flex align-items-center">
                                                        <svg v-if="rKey === 'facebook'" class="lateral-menu-icon" viewBox="0 0 24 24" fill="#ccc">
                                                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                                        </svg>
                                                        <svg v-else-if="rKey === 'instagram'" class="lateral-menu-icon" viewBox="0 0 24 24" fill="#ccc">
                                                            <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678a6.162 6.162 0 100 12.324 6.162 6.162 0 100-12.324zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405a1.441 1.441 0 11-2.882 0 1.441 1.441 0 012.882 0z"/>
                                                        </svg>
                                                        <svg v-else-if="rKey === 'x'" class="lateral-menu-icon" viewBox="0 0 24 24" fill="#ccc">
                                                            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                                                        </svg>
                                                        <svg v-else-if="rKey === 'youtube'" class="lateral-menu-icon" viewBox="0 0 24 24" fill="#ccc">
                                                            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                                                        </svg>
                                                        <svg v-else-if="rKey === 'tiktok'" class="lateral-menu-icon" viewBox="0 0 24 24" fill="#ccc">
                                                            <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                                                        </svg>
                                                        <span class="lateral-menu-text" style="text-transform: capitalize;">{{ rKey }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="child.type === 'languages'" :key="'l-'+cIdx">
                                        <div v-for="(lang, lKey) in skin.languages" :key="lKey" class="lateral-menu-item">
                                            <div class="lateral-menu-item-inner lateral-subitem" :class="{ 'lateral-active': lKey === currentLanguage }" @click.stop="changeLanguage(lKey)">
                                                <div class="d-flex align-items-center">
                                                    <img :src="getLangImage(lKey)" class="lateral-menu-icon" style="width: 22px; height: 22px;" :alt="lang.name">
                                                    <span class="lateral-menu-text">{{ lang.name.split('-')[1]?.trim() || lang.name }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="child.type === 'jivo'" :key="'j-'+cIdx" class="lateral-menu-item">
                                        <div class="lateral-menu-item-inner lateral-subitem" @click.stop="openJivo">
                                            <div class="d-flex align-items-center">
                                                <svg class="lateral-menu-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                    <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
                                                    <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>
                                                </svg>
                                                <span class="lateral-menu-text">{{ child.name }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="child.type === 'link'" :key="'k-'+cIdx" class="lateral-menu-item">
                                        <div class="lateral-menu-item-inner lateral-subitem" @click.stop="openSocial(child.url)">
                                            <div class="d-flex align-items-center">
                                                <svg class="lateral-menu-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                    <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                                                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                                                </svg>
                                                <span class="lateral-menu-text">{{ child.name }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <!-- Desktop: always visible, collapsed (icons only) or expanded (icons + text) -->
        <div v-else class="lateral-sidebar-desktop" :class="{ 'open': isOpen }">
            <div class="lateral-sidebar-body lateral-menu-list" :class="isOpen ? 'p-3' : 'p-2'">
                <div v-for="item in allMenuItems" :key="item.key" class="lateral-menu-item">
                    <div class="lateral-menu-item-inner" :class="{ 'collapsed-item': !isOpen }" :style="item.styles" @click="handleItemClick(item)"
                        :title="!isOpen ? item.name : ''">
                        <div class="d-flex align-items-center" :class="isOpen ? '' : 'justify-content-center'">
                            <img :src="getItemIcon(item)" class="lateral-menu-icon" :alt="item.name">
                            <template v-if="isOpen">
                                <span class="lateral-menu-text flex-grow-1">{{ getItemLabel(item) }}</span>
                                <span v-if="item.amount" class="lateral-menu-amount me-2" :style="skin.lateral_menu.amount_text_color" >{{ item.amount }}</span>
                                <i v-if="item.children" class="fas lateral-chevron" :class="expandedItems[item.key] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            </template>
                        </div>
                    </div>
                    <div v-if="item.children && expandedItems[item.key] && isOpen" class="lateral-submenu mb-1 ms-2">
                        <template v-for="(child, cIdx) in getChildren(item)">
                            <div v-if="child.type === 'redes'" :key="'r-'+cIdx">
                                <div v-for="(red, rKey) in skin.redes" :key="rKey">
                                    <div v-if="red.enabled" class="lateral-menu-item">
                                        <div class="lateral-menu-item-inner lateral-subitem" @click.stop="openSocial(red.url)">
                                            <div class="d-flex align-items-center">
                                                <svg v-if="rKey === 'facebook'" class="lateral-menu-icon" viewBox="0 0 24 24" fill="#ccc">
                                                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                                </svg>
                                                <svg v-else-if="rKey === 'instagram'" class="lateral-menu-icon" viewBox="0 0 24 24" fill="#ccc">
                                                    <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678a6.162 6.162 0 100 12.324 6.162 6.162 0 100-12.324zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405a1.441 1.441 0 11-2.882 0 1.441 1.441 0 012.882 0z"/>
                                                </svg>
                                                <svg v-else-if="rKey === 'x'" class="lateral-menu-icon" viewBox="0 0 24 24" fill="#ccc">
                                                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                                                </svg>
                                                <svg v-else-if="rKey === 'youtube'" class="lateral-menu-icon" viewBox="0 0 24 24" fill="#ccc">
                                                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                                                </svg>
                                                <svg v-else-if="rKey === 'tiktok'" class="lateral-menu-icon" viewBox="0 0 24 24" fill="#ccc">
                                                    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                                                </svg>
                                                <span class="lateral-menu-text" style="text-transform: capitalize;">{{ rKey }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="child.type === 'languages'" :key="'l-'+cIdx">
                                <div v-for="(lang, lKey) in skin.languages" :key="lKey" class="lateral-menu-item">
                                    <div class="lateral-menu-item-inner lateral-subitem" :class="{ 'lateral-active': lKey === currentLanguage }" @click.stop="changeLanguage(lKey)">
                                        <div class="d-flex align-items-center">
                                            <img :src="getLangImage(lKey)" class="lateral-menu-icon" style="width: 22px; height: 22px;" :alt="lang.name">
                                            <span class="lateral-menu-text">{{ lang.name.split('-')[1]?.trim() || lang.name }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="child.type === 'jivo'" :key="'j-'+cIdx" class="lateral-menu-item">
                                <div class="lateral-menu-item-inner lateral-subitem" @click.stop="openJivo">
                                    <div class="d-flex align-items-center">
                                        <svg class="lateral-menu-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
                                            <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>
                                        </svg>
                                        <span class="lateral-menu-text">{{ child.name }}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="child.type === 'link'" :key="'k-'+cIdx" class="lateral-menu-item">
                                <div class="lateral-menu-item-inner lateral-subitem" @click.stop="openSocial(child.url)">
                                    <div class="d-flex align-items-center">
                                        <svg class="lateral-menu-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                                            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                                        </svg>
                                        <span class="lateral-menu-text">{{ child.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SidebarLateral',
    props: ['translation', 'language', 'isOpen', 'isMobile'],
    data() {
        return {
            expandedItems: {}
        }
    },
    computed: {
        allMenuItems() {
            return this.skin?.lateral_menu?.items || [];
        },
        skin() {
            return this.$store.getters['getCurrentSkin'];
        },
        user() {
            return this.$store.getters['getUserData'];
        },
        currentLanguage() {
            return this.$store.getters['getLanguage'];
        },
        jivo_modal_flag() {
            return this.$store.getters['getModalFlag'];
        },
        jivoElement1() {
            return this.$store.getters['jivoElement1'];
        }
    },
    methods: {
        handleItemClick(item) {
            if (item.children) {
                const newState = !this.expandedItems[item.key];
                this.$set(this.expandedItems, item.key, newState);
                return;
            }
            if (this.isMobile) {
                document.getElementById('closeSideBarLateral')?.click();
            }
            if (item.view) {
                this.$store.dispatch('changeView', item.view);
            }
        },
        getItemLabel(item) {
            if (item.key === 'idioma') {
                const lang = this.skin?.languages?.[this.currentLanguage];
                return lang?.name?.split('-')[1]?.trim() || item.name;
            }
            return item.name;
        },
        getItemIcon(item) {
            if (item.key === 'idioma') {
                return this.getLangImage(this.currentLanguage);
            }
            return item.icon;
        },
        getChildren(item) {
            return item.children || [];
        },
        getLangImage(langCode) {
            try {
                return require(`@/assets/images/${langCode}.png`);
            } catch {
                return '';
            }
        },
        openSocial(url) {
            window.open(url, '_blank', 'noopener');
        },
        socialIcon(key) {
            const icons = {
                facebook: 'facebook',
                instagram: 'instagram',
                x: 'twitter',
                youtube: 'youtube',
                tiktok: 'tiktok',
            };
            return icons[key] || key;
        },
        changeLanguage(lang) {
            this.$store.dispatch('setLanguage', lang);
            if (this.isMobile) {
                document.getElementById('closeSideBarLateral')?.click();
            }
        },
        openJivo() {
            if (this.isMobile) {
                document.getElementById('closeSideBarLateral')?.click();
            }
            const jivoElement = this.jivoElement1;
            if (this.jivo_modal_flag) {
                if (jivoElement) {
                    jivoElement.style.display = 'none';
                }
                this.$store.dispatch('setJivo_modal_flag', false);
            } else {
                if (jivoElement) {
                    jivoElement.style.display = 'block';
                    jivo_api.open();
                }
                setTimeout(() => {
                    jivo_api.open();
                }, 600);
                this.$store.dispatch('setJivo_modal_flag', true);
                this.$store.dispatch('setMessage', false);
            }
        }
    }
}
</script>

<style scoped>
.lateral-menu-list {
    font-family: 'Roboto', Arial, sans-serif;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.lateral-sidebar-body {
    background: #1a1a1a !important;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
}

.lateral-offcanvas {
    width: 100% !important;
    margin-top: 50px;
}

.lateral-sidebar-desktop {
    position: fixed;
    left: 0;
    width: 60px;
    height: 90%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    transition: width 0.3s ease;
    background: #1a1a1a !important;
}

.lateral-sidebar-desktop.open {
    width: 280px;
}

.lateral-menu-item-inner {
    cursor: pointer;
    padding: 0.65rem 0.85rem;
    border-radius: 7px;
    transition: background-color 0.2s ease;
    white-space: nowrap;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.05);
}

.lateral-menu-item-inner.collapsed-item {
    padding: 0.65rem 0.5rem;
    justify-content: center;
}

.lateral-menu-item-inner:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.1);
}

.lateral-subitem {
    padding: 0.5rem 0.85rem;
    background: rgba(255, 255, 255, 0.02);
    border: none;
}

.lateral-subitem:hover {
    background: rgba(255, 255, 255, 0.06);
}

.lateral-active {
    background: rgba(255, 255, 255, 0.08);
    border-left: 3px solid #4ade80;
}

.lateral-menu-icon {
    width: 20px;
    height: 20px;
    min-width: 20px;
    object-fit: contain;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.lateral-menu-svg {
    width: 20px;
    height: 20px;
    min-width: 20px;
    color: #ccc;
    flex-shrink: 0;
}

.lateral-menu-text {
    color: #e8e8e8;
    font-size: 0.9rem;
    font-weight: 500;
    letter-spacing: 0.01em;
    margin-left: 10px;
}

.lateral-chevron {
    font-size: 0.65rem;
    color: #666;
    margin-left: 6px;
}

::v-deep .modal-backdrop.show {
    opacity: 0;
}
</style>
